import React from 'react';
import { LanguageContext } from '../../App';
import { useEffect, useRef, useState } from 'react';
import {
    Container, Icon, Language, LanguageButton, LanguageSwitcher, StyledLanguageButtons, StyledArrowIcon
} from './styled';
import ArrowIcon from './arrow.svg';

function LanguageSwitch() {
    const [show, setShow] = useState(false);
    const ref = useRef();

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShow(false);
            }
        }
        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
    return (
        <LanguageContext.Consumer>
            {({ updateLanguage, language }) => (
                <StyledLanguageButtons>
                    <LanguageButton
                        onClick={() => { setShow((show) => !show); }}
                        iscollapsed={show ? 1 : 0}
                    >
                        <Icon src={`/akademia/image/${language['jezyk']}.svg`} width={40} height={20} alt="" />
                        <Container>
                            <Language>{language['jezyk']}</Language>
                            <StyledArrowIcon iscollapsed={1} src={ArrowIcon} />
                        </Container>
                    </LanguageButton>
                    <LanguageSwitcher show={show} ref={ref}>
                        {['pl', 'en', 'ua'].filter((lang) => lang !== language['jezyk']).map((language) => (
                            <LanguageButton
                                key={language}
                                onClick={() => {
                                    updateLanguage(language);
                                    setShow(false);
                                }}
                            >
                                <Icon src={`/akademia/image/${language}.svg`} width={40} height={20} alt="" />
                                <Language>{language}</Language>
                            </LanguageButton>
                        ))}
                    </LanguageSwitcher>
                </StyledLanguageButtons>
            )}
        </LanguageContext.Consumer>
    )
}

export default LanguageSwitch;


// WEBPACK FOOTER //
// ./src/LeftMenu/LanguageSwitch/LanguageSwitch.js